import { RouletteColor } from '@/models/roulette/color';
import { platformAssets } from '@/utils/assets';
import { Image as CoreImage } from '@starsoft/common/components';
import { CardRouletteProps } from './props';
import styles from './styles-card.module.scss';

function CardRoulette({ tile }: CardRouletteProps) {
  if (tile?.type?.image?.includes('white')) {
    return (
      <div className={styles.container}>
        <div
          className={`${styles.container__card} ${styles[`container__card--${RouletteColor.White}`]}`}
        >
          <CoreImage
            className={styles.container__image}
            format="square"
            width={170}
            height={170}
            src={platformAssets.logo.iconWithBackground}
            alt="logo"
            secondarySkeleton
          />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div
        className={`${styles.container__card}`}
        style={
          {
            '--background-color': tile?.type?.color?.toString(),
          } as React.CSSProperties
        }
      >
        <div className={styles.container__card__circle}>
          {tile?.multiplier?.toNumberString()}x
        </div>
      </div>
    </div>
  );
}

export default CardRoulette;
